<template>
    <div>
       <!-- :label="field.label" -->
        <b-form-group
             
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        ><label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
        <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label">({{ field.urduLabel }})</span
            ></label> -->
            <div class="form-group custom-datepicker">
                <date-picker
                    v-model="model"
                    v-validate="{
                        required: field.isRequired,
                    }"
                    class="form-control datepicker-js"
                    format="DD/MM/YYYY"
                    lang="en"
                    :disabled="loading || isDisabled"
                    :data-vv-name="field.label"
                    :class="{
                        'is-invalid': errors.has(field.label),
                    }"
                    :end-at="endAt"
                    :start-at="startAt"
                    :default-value="disabledAfter"
                    @input="onInput"
                ></date-picker>
                <i
                    :class="[
                        {
                            'disable-input': false,
                        },
                        'icon-calendar',
                    ]"
                ></i>
            </div>
            <p v-if="note" class="tax-instruction">
                <i class="icon-error_outline"></i>
                <span>
                    {{ note }}
                </span>
            </p>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import DatePicker from 'vue2-datepicker'

export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        DatePicker,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data: function () {
        // console.log(
        //     'date now: ' +
        //         JSON.stringify(
        //             this.$store.state.registration.form.identityInfo.number
        //         )
        // )
        if (
            this.field.key === 'basicInfo.dateOfBirth' &&
            (this.$store.state.registration.form.identityInfo.number == null ||
                this.$store.state.registration.form.identityInfo.number == '')
        ) {
            let date = new Date()
            // let isMinorAccount = this.$store.store.state.registration.form.basicInfo.isMinorAccount
            // if(isMinorAccount == 'No')
            date.setFullYear(date.getFullYear() - 18)
            this.disabledAfter = date
            return date
        }
        return {
            disabledAfter: new Date(),
            isDisabled: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        /**
         *
         * @return {string}
         */
        note() {
            return this.field.note
        }, // End of note() method

        urduLabel(){
            if(this.$store.state.registration.form.languageOption == 'urd'){
                return true
            } else {
                return false
            }
        },
        endAt() {
            if (
                this.field.key == 'identityInfo.IssuanceDate' ||
                this.field.key == 'accountInfo.guardianIssuanceDate' ||
                this.field.key == 'accountInfo.nomineeIssuanceDate1'
            ) {
                return new Date()
            } else if (this.field.key == 'basicInfo.dateOfBirth') {
                let date = new Date()
                // date.setFullYear(date.getFullYear() - 18)
                // if(this.$store.state.registration.form.basicInfo.isMinorAccount == 'Yes'){
                //     date = new Date()
                // }
                return date
            }
            return ''
        },
        startAt() {
            if (
                this.field.key == 'identityInfo.expiryDate' ||
                this.field.key == 'accountInfo.nomineeExpiryDate1' ||
                this.field.key == 'accountInfo.guardianExpiryDate'
            ) {
                return new Date()
            } else {
                return new Date('01/01/1900')
            }
        },
    }, // End of Component > methods


    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        let dp = document.getElementsByClassName('mx-input')
        
        for(let i=0 ; i< dp.length; i ++){
            dp[i].setAttribute("disabled", true)
        }
        // .setAttribute("disabled", true)

        if (this.field.key == 'identityInfo.expiryDate') {
            if (
                this.$store.state.registration.form.identityInfo
                    .isLifetimeExpiry == 'Yes'
            ) {
                this.field.isRequired = false
                this.isDisabled = true
                this.onInput('')
            }
        }

        if (
            this.field.key == 'accountInfo.guardianIssuanceDate' ||
            this.field.key == 'accountInfo.guardianExpiryDate' 
        ) {
            
                    if (this.$store.state.registration.form.basicInfo
                        .isMinorAccount == 'Yes') {
                        this.field.isRequired = true
                    } else {
                        this.field.isRequired = false
                        this.onInput('')
                    }
                }
            
        
    }, // End of Component > computed

    created() {
        if (this.field.key == 'identityInfo.expiryDate') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.identityInfo
                        .isLifetimeExpiry // could also put a Getter here
                },
                (newValue, oldValue) => {
                    //something changed do something
                    // console.log(oldValue)
                    // console.log(newValue)

                    if (newValue == 'Yes') {
                        this.field.isRequired = false
                        this.isDisabled = true
                        this.onInput('')
                    } else {
                        this.field.isRequired = true
                        this.isDisabled = false
                    }
                }
            )
        }

        if (
            this.field.key == 'accountInfo.guardianIssuanceDate' ||
            this.field.key == 'accountInfo.guardianExpiryDate' 
        ) {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .isMinorAccount
                },
                (newValue) => {
                    if (newValue == 'Yes') {
                        this.field.isRequired = true
                    } else {
                        this.field.isRequired = false
                        this.onInput('')
                    }
                }
            )
        }
        
    },

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the value is updated
         *
         * @return {void}
         */
        onInput(newValue) {
            this.model = newValue
        }, // End of onInput() method

        setAdult() {
            if (this.field.key == 'basicInfo.dateOfBirth') {
                //console.log('18 date')
                let date = new Date()
                date.setFullYear(date.getFullYear() - 18)
                return date
            } else {
                //console.log('default date')

                return new Date()
            }
            //this.model = newValue
        },
    }, // End of Component > mounted
}
</script>
